import React from 'react';
import { Link, Route, Switch, useRouteMatch } from 'react-router-dom';
import {
    Container,
    Dimmer,
    Grid,
    Header,
    Icon,
    Image,
    Label,
    Message,
    Popup,
    Segment
} from 'semantic-ui-react';
import { useAuth } from '../providers';

import Admin from './Admin';
import Announcements from './Announcements';
import Api from './Api';
import ChannelPoints from './ChannelPoints';
import Commands from './Commands';
import Custom from './Custom';
import Donations from './Donations';
import Editor from './Editor';
import KnowledgeBase from './KnowledgeBase';
import Onboarding from './Onboarding';
import Widgets from './Widgets';
// import Cookies from 'js-cookie';

const Dashboard = ({ additional }) => {
    let { user } = useAuth();

    let match = useRouteMatch();
    /*
        let sidebar = false;
        if (Cookies.get('layout') == 'new') {
            sidebar = true;
        }
    */
    return (
        <Container text className='description'>
            <Switch>
                {user.admin ?
                    <Route path={`${match.path}/admin`} component={Admin} />
                    : ''}
                <Route path={`${match.path}/announcements`} component={Announcements} />
                <Route path={`${match.path}/support`} component={KnowledgeBase} />
                <Route path={`${match.path}/commands`} component={Commands} />
                <Route path={`${match.path}/custom/create`} component={Editor} />
                <Route path={`${match.path}/custom/edit/:command`} component={Editor} />
                <Route path={`${match.path}/custom`} component={Custom} />
                <Route path={`${match.path}/channelpoints`} component={ChannelPoints} />
                <Route path={`${match.path}/donations`} component={Donations} />
                <Route path={`${match.path}/widgets`} component={Widgets} />
                <Route path={`${match.path}/onboarding`} component={Onboarding} />

                <Route path={match.path}>
                    <Segment className='dashboard' inverted>
                        <Header inverted>Welcome {user['display']}!</Header>
                        {additional ?
                            <p>{additional}</p>
                            :
                            <p>
                                Welcome to the Twitching of Isaac! Please select an option below:
                            </p>
                        }
                        <Grid columns={3} padded='vertically'>
                            {user.admin ?
                                <Grid.Column>
                                    <Message icon style={{ height: '85px' }} as={Link} to='/dashboard/admin'>
                                        <Icon name='eye' />
                                        <Message.Content>
                                            <Message.Header>Admin View</Message.Header>
                                            Admin only tools.
                                        </Message.Content>
                                    </Message>
                                </Grid.Column>
                                : ''}
                            <Grid.Column>
                                <Message icon style={{ height: '85px' }} as={Link} to='/dashboard/support'>
                                    <Icon name='book' />
                                    <Message.Content>
                                        <Message.Header>Knowledge Base</Message.Header>
                                        Get help on installing, running, and using the mod.
                                    </Message.Content>
                                </Message>
                            </Grid.Column>
                            <Grid.Column>
                                <Message icon style={{ height: '85px' }} as={Link} to='/dashboard/announcements'>
                                    <Icon name='newspaper outline' />
                                    <Message.Content>
                                        <Message.Header>Announcements</Message.Header>
                                        View latest release and feature announcements.
                                    </Message.Content>
                                </Message>
                            </Grid.Column>
                            <Grid.Column>
                                <Message icon style={{ height: '85px' }} as={Link} to='/dashboard/commands'>
                                    <Icon name='wizard' />
                                    <Message.Content>
                                        <Message.Header>Commands</Message.Header>
                                        Advanced command configuration.
                                    </Message.Content>
                                </Message>
                            </Grid.Column>
                            <Grid.Column>
                                <Message icon style={{ height: '85px' }} as={Link} to='/dashboard/custom'>
                                    <Icon name='edit outline' />
                                    <Message.Content>
                                        <Message.Header>Custom Commands</Message.Header>
                                        Create Custom Commands.
                                    </Message.Content>
                                </Message>
                            </Grid.Column>
                            <Grid.Column>
                                <Message icon style={{ height: '85px' }} as={Link} to='/dashboard/channelpoints'>
                                    <Image src='/images/channelpoints.png' />
                                    <Message.Content>
                                        <Message.Header>Channel Points</Message.Header>
                                        Manage Channel Point Redemptions.
                                    </Message.Content>
                                </Message>
                            </Grid.Column>
                            <Grid.Column>
                                <Message icon style={{ height: '85px' }} as={Link} to='/dashboard/donations'>
                                    <Popup content='This is a Beta feature! Expect bugs and things to change!' trigger={<Label as='a' color='purple' corner='right' icon='lab' />} />
                                    <Icon name='dollar sign' />
                                    <Message.Content>
                                        <Message.Header>Donations</Message.Header>
                                        Accept donations, and configure incentives.
                                    </Message.Content>
                                </Message>
                            </Grid.Column>
                            <Grid.Column>
                                <Message icon style={{ height: '85px' }} as={Link} to='/dashboard/widgets'>
                                    <Icon name='object group outline' />
                                    <Message.Content>
                                        <Message.Header>Stream Wigets</Message.Header>
                                        Widgets for OBS related to the mod interaction.
                                    </Message.Content>
                                </Message>
                            </Grid.Column>
                            <Grid.Column>
                                <Message icon style={{ height: '85px' }} as='a' href='https://discord.gg/FtJyJNcz2k'>
                                    <Icon name='discord' />
                                    <Message.Content>
                                        <Message.Header>Discord</Message.Header>
                                        Access the Twitching of Isaac community Discord.
                                    </Message.Content>
                                </Message>
                            </Grid.Column>
                            <Grid.Column>
                                <Message icon style={{ height: '85px' }} as='a' href='https://patreon.com/twitchingofisaac'>
                                    <Icon name='patreon' />
                                    <Message.Content>
                                        <Message.Header>Patreon</Message.Header>
                                        Support the creator via Patreon (and get swag)!
                                    </Message.Content>
                                </Message>
                            </Grid.Column>
                            <Grid.Column>
                                <Message icon style={{ height: '85px' }}>
                                    <Dimmer active>
                                        <Header as='h3' inverted>
                                            Coming Soon!
                                        </Header>
                                    </Dimmer>
                                    <Image src='/images/tiktok.png' />
                                    <Message.Content>
                                        <Message.Header>Tik Tok</Message.Header>
                                        Connect your Tik Tok Live Stream.
                                    </Message.Content>
                                </Message>
                            </Grid.Column>
                            <Grid.Column>
                                <Message icon style={{ height: '85px' }}>
                                    <Dimmer active>
                                        <Header as='h3' inverted>
                                            Coming Soon!
                                        </Header>
                                    </Dimmer>
                                    <Icon name='trophy' />
                                    <Message.Content>
                                        <Message.Header>Challenges</Message.Header>
                                        Create custom challenges.
                                    </Message.Content>
                                </Message>
                            </Grid.Column>
                        </Grid>
                    </Segment>
                </Route>
            </Switch>
        </Container>
    )
};

export default Dashboard;
